import { render, staticRenderFns } from "./openSidepanel.vue?vue&type=template&id=e5795ec8"
import script from "./openSidepanel.vue?vue&type=script&lang=js"
export * from "./openSidepanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports